import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { TvSvg } from './svg/tv';

export const TvIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TvSvg} {...props} />
);
